import type { FC } from 'react';

import type { IconProps } from '@crehana/compass.icons.fill/types';
import CheckmarkCircle from '@crehana/compass.icons.outline/CheckmarkCircle';
import Edit from '@crehana/compass.icons.outline/Edit';
import Eye from '@crehana/compass.icons.outline/Eye';
import Info from '@crehana/compass.icons.outline/Info';
import type { TTypeProject } from '@crehana/compass.ui';

const useSelectIconType = (type: TTypeProject): FC<IconProps> => {
  const selectIconType = () => {
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (type === 'pending') return Info;
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (type === 'underReview') return Eye;
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (type === 'remarks') return Edit;
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (type === 'certified') return CheckmarkCircle;
    return Info;
  };

  const IconComponent = selectIconType();

  return IconComponent;
};

export default useSelectIconType;
